import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { logUsage } from 'owa-analytics';
import { embargoedMarkets, supportedMarkets, getAdMarketPublishGroupCode, IsPremiumConsumerUser, IsChildConsumerUser, } from './sharedAdsUtils';
var showAds;
export function areAdsEnabled() {
    // caching this value as it doesn't change per session
    if (typeof showAds != 'undefined') {
        return showAds;
    }
    if (!isMailFeatureEnabled('fwk-ads')) {
        showAds = false;
    }
    else {
        var adsNotEnabledString = null;
        if (IsPremiumConsumerUser()) {
            adsNotEnabledString = 'AdPaidUser';
        }
        else if (embargoedMarkets.includes(getAdMarketPublishGroupCode()) ||
            (isMailFeatureEnabled('fwk-ads-disableDefaultPG') &&
                !supportedMarkets.includes(getAdMarketPublishGroupCode()))) {
            adsNotEnabledString = 'NonSupportedMarket';
        }
        else if (IsChildConsumerUser()) {
            adsNotEnabledString = 'ChildAccount';
        }
        showAds = adsNotEnabledString == null;
        if (showAds) {
            logUsage('AdsbarEnabled');
        }
        else {
            logUsage('AdsbarNotEnabled', [adsNotEnabledString]);
        }
    }
    return showAds;
}
export function setShowAds(value) {
    showAds = value;
}
//# sourceMappingURL=adsUtilities.js.map